import { isTour } from "@/lib/predicates";

function isCategoryOption(
  option: Catalog.SelectedOption
): option is Catalog.Category.SelectedOption {
  return option.name === "category";
}

function isDifficultyOption(
  option: Catalog.SelectedOption
): option is Catalog.Difficulty.SelectedOption {
  return option.name === "difficulty";
}

function isDistanceOption(
  option: Catalog.SelectedOption
): option is Catalog.Distance.SelectedOption {
  return option.name === "distance";
}

export function getFilters<T extends Catalog.SelectedOption>(
  options: Array<T>
) {
  return options.map((option) => {
    if (isCategoryOption(option)) {
      return byCategory(option.value);
    } else if (isDifficultyOption(option)) {
      return byDifficulty(option.value);
    } else if (isDistanceOption(option)) {
      return byDistance(option.value);
    } else {
      throw new Error(`Mapping function with name '${name}' not found!`);
    }
  });
}

export function apply(filters: ReturnType<typeof getFilters>) {
  return (ooi: Travelguide.OOI) => filters.every((by) => by(ooi));
}

export function byCategory(value: Catalog.Category.Value) {
  const categoryIds = value ? (Array.isArray(value) ? value : [value]) : null;
  return (ooi: Travelguide.OOI) =>
    !categoryIds ||
    (ooi.category.path !== undefined &&
      categoryIds.some((id) => ooi.category.path?.includes(id)));
}

export function byDifficulty(value: Catalog.Difficulty.Value) {
  return (ooi: Travelguide.OOI) =>
    !value || !isTour(ooi) || ooi.rating.difficulty === value;
}

export function byDistance(value: Catalog.Distance.Value) {
  return (ooi: Travelguide.OOI) =>
    !value ||
    !isTour(ooi) ||
    (value[0] <= ooi.distance && (value[1] ? ooi.distance <= value[1] : true));
}
